import { IppicaQuoteFinaliBox } from 'features/ippica/components/ippicaQuote/ippicaQuoteFinaliBox';
import { QuoteFinali } from 'lib/api/virtual/virtualUltimiRisultatiResponseApi';
import styles from './VirtualScommesseQuotePlurime.module.scss';
export type VirtualScommesseQuotePlurimeProps = {
  quoteFinali: Array<QuoteFinali>;
};
export const VirtualScommesseQuotePlurime = ({ quoteFinali }: VirtualScommesseQuotePlurimeProps) => {
  return (
    <div className={styles.quotePlurimeRisultatiContainer}>
      {quoteFinali.map((item, index) => (
        <IppicaQuoteFinaliBox
          key={`${item}-${index}`}
          title={item.title}
          esitoList={item.esitoList}
          containerClassName={styles.quotePlurimeRisultati}
        />
      ))}
    </div>
  );
};
